<template>
    <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M17 17H15V8H17V17ZM13 17H11V12H13V17ZM9 17H7V10H9V17ZM19 3H5C3.89 3 3 3.89 3 5V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V5C21 3.89 20.1 3 19 3Z"
            fill="currentColor"
        />
    </svg>
</template>

<script>
export default {
    name: "ReportIcon"
};
</script>
